/*
* Commons
* -------------------------
*/
export const SET_ERROR = "setError"
export const SET_NOTIFICATIONS = "setNotifcations"
/*
* Const Accounts
* -------------------------
*/
export const CLEAR_AUTH = "clearAuth"
export const SET_AUTH = "setAuth"
export const SET_USER_LOADING = "setUserMainLoading"
export const SET_ACCOUNT_ERROR = "setAccountError"
export const SET_SETTINGS_DRAWER = "setUserSettingsDrawer"
export const SET_ACCOUNT_LOGO_ANIMATION_DONE = "setAccountLogoAnimation"
export const SET_UPDATE_ACCOUNT = "setUpdateAccount"
export const SET_USER_UPDATING = "setUserUpdating"
/*
* Const Profiles
* -------------------------
*/
export const SET_CURRENT_PROFILE = "setCurrentProfile"  
export const SET_PROFILE_LOADING = "setProfileLoading"
export const CLEAR_CURRENT_PROFILE = "clearProfile"
export const CLEAR_PROFILE_POST_LIST = "clearProfilePostList"
export const SET_PROFILE_POST_LIST_LOADING = "setProfilePostListLoading"
export const SET_PROFILE_SAVED_POST_LIST_LOADING = "setProfileSavedPostListLoading"
export const SET_PROFILE_TAGGED_POST_LIST_LOADING = "setProfileTaggedPostListLoading"
export const PUSH_PROFILE_POST = "pushProfilePost"
export const PUSH_SAVED_PROFILE_POST = "pushSavedProfilePost"
export const PUSH_TAGGED_PROFILE_POST = "pushTaggedProfilePost"
export const UPDATE_ACTIVE_PROFILE = "updateActiveProfile"
export const PUSH_FOLLOWERS = "pushFollowers"
export const PUSH_FOLLOWING = "pushFollowing"
export const UPDATE_FOLLOWER = "updateFollower"
export const UPDATE_FOLLOWING = "updateFollowing"
export const CLEAR_PROFILE_FOLLOWERS = "clearProfileFollowers"
export const CLEAR_PROFILE_FOLLOWING = "clearProfileFollowing"
/*
* Const Media
* -------------------------
*/
export const ADD_FILE = "addFile"
export const REMOVE_FILE = "removeFile"
export const UPDATE_FILE = "updateFile"
export const CLEAR_FILES = "clearFiles"

/*
* Const post
* -------------------------
*/
export const CREATING_POST = "creatingPost"
export const CLEAR_CURRENT_POST = "clearCurrentPost"
export const CLEAR_POST_LIST = "clearPostList"
export const SET_CURRENT_POST = "setCurrentPost"
export const UPDATE_CURRENT_POST = "updateCurrentPost"
export const CURRENT_POST_LOADING = "currentPostLoading"
export const POST_LIST_LOADING = "postListLoading"
export const PUSH_POST = "pushPost"
export const SET_ATTACHMENTS_LOADING = "setAttachmentLoading"
export const SET_SINGLE_ATTACHMENT_LOADING = "setSingleAttachmentLoading"
export const SET_ATTACHMENT_OFFSET = "setAttachmentOffset"
export const UPDATE_POST = "updatedPost"
export const PUSH_LIKED_USERS = "pushLikedUsers"
export const UPDATE_LIKED_USER = "updateLikedUser"
export const CLEAR_LIKED_USERS = "clearLikedUsers"

/*
* Const Suggestions
* -------------------------
*/
export const PUSH_SUGGESTED_USERS = "pushSuggestedUsers"
export const UPDATE_SUGGESTED_USER = "updateSuggestedUser"
export const CLEAR_SUGGESTED_USERS = "clearSuggestedUsers"

/*
* Const Search
* -------------------------
*/
export const CLEAR_SEARCH_LIST = "clearSearchList"
export const PUSH_SEARCH_LIST = "pushSearchList"
export const UPDATE_SEARCH_LIST = "updateSearchList"

/*
* Const Explore
* -------------------------
*/
export const CLEAR_EXPLORE_LIST = "clearExploreList"
export const PUSH_EXPLORE_LIST = "pushExploreList"
export const UPDATE_EXPLORE_LIST = "updateExploreList"
